import React from 'react';
import PropTypes from "prop-types";

const PaymentSucceeded = ({ todaysDate, totalToPay, isAdmin, auctionId }) => {
    return (
        <article id="paymentComplete" className="message is-success is-normal">
            <div className="message-header">
                <span>Thank you for your payment</span>
                <button className="delete is-small js-close-message" aria-label="close"></button>
            </div>
            <div className="message-body">
                <p>
                    We have sent a receipt to your email.
                    </p>
                <p>
                    <b>
                        Payment date:{' '}
                    </b>
                    {todaysDate}
                    <br />
                    <b>
                        Amount:{' '}
                    </b>
                    {totalToPay}
                </p>
                {
                    isAdmin ? <p>
                        <a href={`/myauction/outstandingpayments/index/${auctionId}`}>
                                Back to payments
                        </a>
                    </p>: null
                }
            </div>
        </article>
        );
};

PaymentSucceeded.propTypes = {
    todaysDate: PropTypes.string.isRequired,
    totalToPay: PropTypes.string.isRequired,
    isAdmin: PropTypes.bool.isRequired,
    auctionId: PropTypes.number.isRequired
}

export default PaymentSucceeded;


